export const patientConnectUrl = {
    base: "https://app.longboat.com",
    //rel: "/api/v1/Longboat/15/patient_connect",
    get absolutePath() {
        return this.base + this.rel;
    },
}

export const patientConnectHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    //'Authorization': '',
}

export const googleMapApiKey = "AIzaSyDYt4g3PR9n2P5HF7NivSCidrKFvj9Nojg";
export const googleMapUrl = `https://maps.googleapis.com/maps/api/js?key=${googleMapApiKey}`;

// Animation
export const isPageAnimationEnabled = true;

// Login Page Style
export const isDefaultStyle = false; // true or false

//Images
export const logoPath = "study_logo.png";

//Pendo Analytics
export const pendoKey = '055e0a8b-b58d-43b8-6bc3-991ad9ea3974';
export const studyURL = "fibroneer-ipf.longboat.com";
export const sponsorName = "BoehringerIngelheim";
export const studyId = "BOEH387";
export const AppType = "PRW";
export const pendoAccountName = studyId + '_' + AppType;

// Authentication
export const cookieExpiryTimeInMins = 10;
export const passwords = [{
    key: "pass", // key used for storing this password in cookie
    value: "Longboat1!", // password
    toRoute: "/", // go to this route/url after successful authentication
}, ];

// i18n localisation configuration
export const defaultLocale = "en";
export const supportedLocales = [
    // "cs",
    // "ct",
    //  "de",
    //  "el",
    "en",
    //  "gs",
    //  "hr",
    //  "hu",
    //  "iw",
    //  "ka",
    //  "nl",
    //  "no",
    // "pt",
    //  "sf",
    // "sl",
    // "sp",
    // "sv",
];

// Google map study Sites
export let gMapOptions = {
    center: {
        lat: 33.9466277,
        lng: -84.3320862,
    },
    scrollwheel: false,
    zoom: 10,
    styles: [{
            "featureType": "all",
            "elementType": "geometry.fill",
            "stylers": [{
                "weight": "2.00"
            }]
        },
        {
            "featureType": "all",
            "elementType": "geometry.stroke",
            "stylers": [{
                "color": "#9c9c9c"
            }]
        },
        {
            "featureType": "all",
            "elementType": "labels.text",
            "stylers": [{
                "visibility": "on"
            }]
        },
        {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [{
                "color": "#f2f2f2"
            }]
        },
        {
            "featureType": "landscape",
            "elementType": "geometry.fill",
            "stylers": [{
                "color": "#ffffff"
            }]
        },
        {
            "featureType": "landscape.man_made",
            "elementType": "geometry.fill",
            "stylers": [{
                "color": "#ffffff"
            }]
        },
        {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [{
                "visibility": "off"
            }]
        },
        {
            "featureType": "road",
            "elementType": "all",
            "stylers": [{
                    "saturation": -100
                },
                {
                    "lightness": 45
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry.fill",
            "stylers": [{
                "color": "#eeeeee"
            }]
        },
        {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [{
                "color": "#7b7b7b"
            }]
        },
        {
            "featureType": "road",
            "elementType": "labels.text.stroke",
            "stylers": [{
                "color": "#ffffff"
            }]
        },
        {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [{
                "visibility": "simplified"
            }]
        },
        {
            "featureType": "road.arterial",
            "elementType": "labels.icon",
            "stylers": [{
                "visibility": "off"
            }]
        },
        {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [{
                "visibility": "off"
            }]
        },
        {
            "featureType": "water",
            "elementType": "all",
            "stylers": [{
                    "color": "#46bcec"
                },
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "geometry.fill",
            "stylers": [{
                "color": "#c8d7d4"
            }]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.fill",
            "stylers": [{
                "color": "#070707"
            }]
        },
        {
            "featureType": "water",
            "elementType": "labels.text.stroke",
            "stylers": [{
                "color": "#ffffff"
            }]
        }
    ]
}
export let getSites = (googleMapObj, mapObj) => {
    let icon = {
        url: "/map.png",
    };
    let sites = [
        new googleMapObj.maps.Marker({
            active: true,
            title: "Destin Pulmonary Critical Care",
            email: "dr.davephillips@gmail.com",
            address: "249 Mack Bayou Loop, Suite 201, Santa  Rosa Beach, FL, 32459",
            position: {
                lat: 30.378206277841066,
                lng: -86.30097128896998,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "St.Francis Medical Institute",
            email: "cpreston@stfrancismed.com",
            address: "804 N.Belcher Rd, Clearwater, FL, 33765",
            position: {
                lat: 27.974030590903645,
                lng: -82.74677726017843,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Lowcountry Lung and Critical Care",
            email: "smoultrie@lowcountrylung.com",
            address: "9150-B Medcom Street, Charleston, SC, 29406",
            position: {
                lat: 32.976229891980566,
                lng: -80.06887294474359,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "The Oregon Clinic",
            email: "mday@orclinic.com",
            address: "1111 NE 99th Avenue Suite 200, Portland, OR, 97220",
            position: {
                lat: 45.53114296330621,
                lng: -122.56288565792848,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Washington University School of Medicine",
            email: "hperkins@wustl.edu",
            address: "4523 Clayton Avenue, Saint Louis, MO, 63110",
            position: {
                lat: 38.63376558670938,
                lng: -90.26123440228616,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Florida Lung Asthma and Sleep Specialists",
            email: "dkrause@floridalungdoctors.com",
            address: "3840 Polynesian Isle Blvd, Kissimmee, FL, 34746",
            position: {
                lat: 28.346489241969376,
                lng: -81.48725866017195,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Southern Research Center",
            email: "Aeverhart@southeasternresearchcenter.com",
            address: "2932 Lyndhurst Avenue, Suite 110, Winston Salem, NC, 27103",
            position: {
                lat: 36.079031917888315,
                lng: -80.29251351584128,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "The University of Kansas Medical Center",
            email: "kdonnelly@kumc.edu",
            address: "2106 Olathe Blvd. Wescoe 1032, Kansas City, KS, 66160",
            position: {
                lat: 39.06193898791689,
                lng: -94.61049245254529,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "University of Pennsylvania School of Medicine",
            email: "MaryElizabeth.Kreider@pennmedicine.upenn.edu",
            address: "5004 Gibson Building, 3400 Spruce Street, Philadelphia, PA, 19104",
            position: {
                lat: 39.95003724952818,
                lng: -75.19295818691359,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "NorthShore University HealthSystem",
            email: "dlarsen@northshore.org",
            address: "2650 Ridge Avenue, Room G147, Evanston, IL, 60201",
            position: {
                lat: 42.06562884129248,
                lng: -87.68436653103393,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "University of Nebraska Medical Center",
            email: "clandgren@unmc.edu",
            address: "601 S Saddle Creek Road, Omaha, NE, 68106",
            position: {
                lat: 41.25474639247993,
                lng: -95.98232827338518,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Infinity Medical Research, Inc.",
            email: "amorton@infinitymedicalresearch.com",
            address: "370 Faunce Corner Road - 2nd Floor, North Dartmouth, MA, 02747",
            position: {
                lat: 41.66435853945127,
                lng: -70.99173743104446,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Clinical Trials Center of Middle Tennessee",
            email: "jwallan@ctcmidtn.com",
            address: "100 Covey Drive, Suite 307, Franklin, TN, 37067",
            position: {
                lat: 35.915184654660465,
                lng: -86.82001090234999,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Lenox Hill Hospital",
            email: "vroselli@northwell.edu",
            address: "130 East 77th Street, 9 Black Hall, New York, NY, 10075",
            position: {
                lat: 40.775699571172865,
                lng: -73.96377230223257,
            },
            icon: icon,
            map: mapObj,
        }),

        new googleMapObj.maps.Marker({
            active: true,
            title: "The Lung Research Center, LLC",
            email: "anna.shipp@stlukes-stl.com",
            address: "222 S. Woods Mill Rd Suite 300N, Chesterfield, MO, 63017",
            position: {
                lat: 38.65263376755438,
                lng: -90.50255077529575,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Premier Pulmonary Critical Care and Sleep Medicine",
            email: "sally@premierpsm.com",
            address: "5012 South US Highway 75, Suite 200, Dension, TX, 75020",
            position: {
                lat: 33.73215424678945,
                lng: -96.58461834096367,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Renown Regional Medical Center",
            email: "angelica.villa@renown.org",
            address: "1155 Mill Street Mailstop: G14, Reno, NV, 89502",
            position: {
                lat: 39.52647494430326,
                lng: -119.79523522925415,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Advanced Pulmonary Research Institute ",
            email: "aprirnir@gmail.com",
            address: "13005 Southern Boulevard ,Suite 235, Loxahatchee, FL, 33470",
            position: {
                lat: 26.682169941851445,
                lng: -80.25048858903516,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Yale University Medical Center",
            email: "linda.eford@yale.edu",
            address: "15 York Street, LLCI 101, New Haven, CT, 06510",
            position: {
                lat: 41.30362893287994,
                lng: -72.93516498872393,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Cardiopulmonary Research",
            email: "alvaroacc@aol.com",
            address: "Maramar Plaza, 101 San Patricio Avenue, Suite 1240, Guaynabo, PR, 00968",
            position: {
                lat: 18.409754381624523,
                lng: -66.10371364681562,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Infinity Medical Research, Inc.",
            email: "lfernandes@infinitymedicalresearch.com",
            address: "73 Highland Avenue, East Providence, RI, 02914",
            position: {
                lat: 41.80458004211353,
                lng: -71.3410938733707,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Virginia Mason Medical Center (VMMC)-Seattle Main Campus",
            email: "daire.byrne@vmfh.org",
            address: "1100 9th Avenue, MS: D4-CRP, Seattle, WA, 98101",
            position: {
                lat: 47.60969224217376,
                lng: -122.32774191553798,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Temple University Hospital",
            email: "breathe@tuhs.temple.edu",
            address: "3401 N Broad Street, Philadelphia, PA, 19140",
            position: {
                lat: 40.00604321260732,
                lng: -75.1523699175922,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "The University of Texas Health Science Center at Houston, McGovern Medical School",
            email: "mary.rangel@uth.tmc.edu",
            address: "6410 Fannin St Suite 833, Houston, TX, 77030",
            position: {
                lat: 29.7145396975182,
                lng: -95.39757057364241,
            },
            icon: icon,
            map: mapObj,
        }),

        ///
        new googleMapObj.maps.Marker({
            active: true,
            title: "St. Elizabeth's Medical Center - SMG Pulmonary, Critical Care and Sleep Medicine",
            email: "alexandra.cawood@steward.org",
            address: "736 Cambridge St, Boston, MA, 02135",
            position: {
                lat: 42.34904325088619,
                lng: -71.14949738832159,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Creighton University",
            email: "roberteriksen@creighton.edu",
            address: "7710 Mercy Road, Medical Building One, Suite 28. Omaha, NE, 68124",
            position: {
                lat: 41.23961393805257,
                lng: -96.03096884231357,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Piedmont Hospital",
            email: "Olayinka.elemide@piedmont.org",
            address: "1968 Peachtree Road NW, Atlanta, GA, 30309",
            position: {
                lat: 33.808683101817,
                lng: -84.39527540014815,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "UT Health San Antonio",
            email: "pomroy@uthscsa.edu",
            address: "8300 Floyd Curl Drive, MC7885, San Antonio, TX, 78229",
            position: {
                lat: 29.515199148717667,
                lng: -98.58164205975257,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Louisville Pulmonary Care",
            email: "wendihaller@gmail.com",
            address: "4003 Kresge Way, Ste 312, Louisville, KY, 40207",
            position: {
                lat: 38.23965403562363,
                lng: -85.6398555749267,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Medstar Georgetown",
            email: "amen.m.hamed@gunet.georgetown.edu",
            address: "3800 Reservoir Road, NW, 3PHC Suite 3004, Washington, DC, 20007",
            position: {
                lat: 38.911659176370605,
                lng: -77.07540161723914,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "University of Florida Gainesville Campus",
            email: "Rosie.kizza@medicine.ufl.edu",
            address: "1600 SW Archer Road, Gainesville, FL, 32610",
            position: {
                lat: 29.639764056905975,
                lng: -82.342442786733,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "University of Michigan/Michigan Medicine Dept of Internal Medicine/Pulmonary Critical Care Medicine",
            email: "ccgraft@med.umich.edu, cflah@med.umich.edu",
            address: "1500 E. Medical Center Drive, Ann Arbor, MI, 48109",
            position: {
                lat: 42.27815471315333,
                lng: -83.73824555935983,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Jefferson University Hospitals",
            email: "jesse.roman@jefferson.edu",
            address: "211 South 9th Street, Suite 300, Philadelphia	PA, 19107",
            position: {
                lat: 39.94805680807158,
                lng: -75.15568118429262,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "National Jewish Health",
            email: "fierk@njhealth.org",
            address: "1400 Jackson Street, Suite K333, Denver, CO, 80206",
            position: {
                lat: 39.73923988079856,
                lng: -104.94210137291876,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Beaumont Research Institute South Building",
            email: "coleen.tessmar@corewellhealth.org",
            address: "3811 W 13 Mile Road, Royal Oak, MI, 48073",
            position: {
                lat: 42.51300616602208,
                lng: -83.19404452681043,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Weill Cornell Medicine, Pulmonary",
            email: "kke4001@med.cornell.edu",
            address: "1305 York Ave, 10th floor, New York, NY, 10021",
            position: {
                lat: 40.76452781230875,
                lng: -73.95352019661532,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Allegheny Health Network",
            email: "paige.rutter@ahn.org",
            address: "Allegheny General Hospital/15th floor, South Tower, Room 15J4, Pittsburg, PA, 15212",
            position: {
                lat: 40.457807219790304,
                lng: -80.00404832950278,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Stony Brook University Hospital | Division of Pulmonary and Critical Care",
            email: "jacqueline.skarre@stonybrookmedicine.edu",
            address: "101 Nicholls Road Health Sciences Center/ T-17-040, Stony Brook, NY, 11794",
            position: {
                lat: 40.90846570598056,
                lng: -73.11541899620374,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "The Ohio State University - Martha Morehouse Outpatient Care Pavilion",
            email: "Benjamin.hood2@osumc.edu",
            address: "2050 Kenny Road, Suite 2600, Columbus, OH, 43221",
            position: {
                lat: 40.00144833281841,
                lng: -83.03144691523957,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Mayo Clinic, Rochester",
            email: "Daley.shannon@mayo.edu",
            address: "200 First Street SW, Gonda 18S RM144, Rochester, MN, 55905",
            position: {
                lat: 44.0228817734333,
                lng: -92.46674055262368,
            },
            icon: icon,
            map: mapObj,
        }),
        new googleMapObj.maps.Marker({
            active: true,
            title: "Christiana Hospital",
            email: "Lauren.c.duddy@christianacare.org ",
            address: "4755 Ogletown- Stanton Rd, Newark, DE, 19718",
            position: {
                lat: 39.68636651242981,
                lng: -75.67183394520067,
            },
            icon: icon,
            map: mapObj,
        }),

    ];
    return sites;
};

/* ================= Eligibility form  ===================== */
export const answers = {
    YES: "yes_a",
    NO: "no_a",
    MAYBE: "maybe_a",
    DONTKNOW: "dk_a",
};

export const eligibilityForm = (context) => [

    // Question 1
    {
        question: context.$t("question1"),
        choices: [{
                value: answers.YES,
                text: context.$t("yes_a"),
            },
            {
                value: answers.NO,
                text: context.$t("no_a"),
            },
        ],
        correctAnswers: [answers.YES],
        isActive: false,
    },

    // Question 2
    {
        question: context.$t("question2"),
        choices: [{
                value: answers.YES,
                text: context.$t("yes_a"),
            },
            {
                value: answers.NO,
                text: context.$t("no_a"),
            },
        ],
        correctAnswers: [answers.YES],
        isActive: false,
    },

    // Question 3
    {
        question: context.$t("question3"),
        choices: [{
                value: answers.YES,
                text: context.$t("yes_a"),
            },
            {
                value: answers.NO,
                text: context.$t("no_a"),
            },
            {
                value: answers.MAYBE,
                text: context.$t("maybe_a"),
            },
        ],
        correctAnswers: [answers.NO, answers.MAYBE],
        isActive: false,
    },

    // Question 4
    {
        question: context.$t("question4"),
        choices: [{
                value: answers.YES,
                text: context.$t("yes_a"),
            },
            {
                value: answers.NO,
                text: context.$t("no_a"),
            }, {
                value: answers.DONTKNOW,
                text: context.$t("dk_a"),
            },
        ],
        correctAnswers: [answers.YES, answers.NO, answers.DONTKNOW],
        isActive: false,
    },
];

export const prwEligibilityForm = (context) => [

    // Question 1
    {
        question: context.$t("prw_question1"),
        choices: [{
                value: answers.YES,
                text: context.$t("yes_a"),
            },
            {
                value: answers.NO,
                text: context.$t("no_a"),
            },
        ],
        correctAnswers: [answers.YES],
        isActive: false,
    },

    // Question 2
    {
        question: context.$t("prw_question2"),
        choices: [{
                value: answers.YES,
                text: context.$t("yes_a"),
            },
            {
                value: answers.NO,
                text: context.$t("no_a"),
            },
        ],
        correctAnswers: [answers.YES],
        isActive: false,
    },

    // Question 3
    {
        question: context.$t("prw_question3"),
        choices: [{
                value: answers.YES,
                text: context.$t("yes_a"),
            },
            {
                value: answers.NO,
                text: context.$t("no_a"),
            },
            {
                value: answers.MAYBE,
                text: context.$t("maybe_a"),
            },
        ],
        correctAnswers: [answers.NO, answers.MAYBE],
        isActive: false,
    },

    // Question 4
    {
        question: context.$t("prw_question4"),
        choices: [{
                value: answers.YES,
                text: context.$t("yes_a"),
            },
            {
                value: answers.NO,
                text: context.$t("no_a"),
            }, {
                value: answers.DONTKNOW,
                text: context.$t("dk_a"),
            },
        ],
        correctAnswers: [answers.YES, answers.NO, answers.DONTKNOW],
        isActive: false,
    },
];


// Patient Connect Sites
import ireland from "@/sites/ireland.js";
import usa from "@/sites/us.js";
export const sites = [{
        id: "ie",
        name: "Ireland",
        states: ireland,
    },
    {
        id: "us",
        name: "United States",
        states: usa,
    },
];